import React, { useContext, useState, useEffect, useMemo } from 'react';
import BaseComponentInternas from '../../Components/BaseComponentInternas';
import Destaques from '../../Components/Destaques';
import { ContextoListaApartamentos } from '../../Components/ApartamentList/contextoImoveis';

import AccessData from '../../Components/AccessData';
import PersonalData from '../../Components/PersonalData';
import SocialMedias from '../../Components/SocialMedias';
import { ContextGetMeuPerfil } from '../../services/getMeuPerfil';
import {
  ButtonDanger,
  ButtonPrimary,
  Spinner,
} from '../../Components/StyledComponent';
import isObjectDeepEquals from '../../Utils/isObjectDeepEquals';
import MessagePopUp from '../../Components/MessagePopup';
import HeaderStroke from '../../Components/HeaderStroke';
import HeaderSection from '../../Components/HeaderSection';
import AlertErrorMessage from '../../Components/ErrorMessage';

const MeuPerfil = () => {
  const { tema } = useContext(ContextoListaApartamentos);
  const initialState = {
    Nome: '',
    Telefone: '',
    Celular: '',
    Email: '',

    Enderecos: [
      {
        Id: '',
        Cep: '',
        Logradouro: '',
        Bairro: '',
        Cidade: '',
        Estado: '',
        Numero: '',
        Complemento: '',
      },
    ],
  };

  const [isLoading, setIsLoading] = useState(false);
  const [haveAnyFieldsEditing, setHaveAnyFieldsEditing] = useState(false);
  const [userData, setUserData] = useState({ ...initialState });
  const [userDataValidation, setUserDataValidation] = useState({});
  const [userDataCopy, setUserDataCopy] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErroPhoneDuplicatedModal, setShowErroPhoneDuplicatedModal] =
    useState(false);
  const [showGenericErrorModal, setShowGenericErrorModal] = useState(false);
  const [isErrorApiCep, setIsErrorApiCep] = useState(false);
  const { importDataMeuPerfil, updatePerfil } = useContext(ContextGetMeuPerfil);

  const isUserDataEqualsUserDataCopy = useMemo(() => {
    console.log({ userDataCopy, userData });
    return isObjectDeepEquals(userDataCopy, userData);
  }, [userDataCopy, userData]);

  function toggleHaveAnyFieldsEditing() {
    setHaveAnyFieldsEditing(!haveAnyFieldsEditing);
  }

  async function getUserData() {
    setIsLoading(true);
    const result = await importDataMeuPerfil();
    setIsLoading(false);
    // caso aconteça algum erro e o formulário retorne undefined ou vazio ou algo do tipo, os dois formulários são setados como vazios
    setUserData(result);
  }

  async function handleUpdateProfile() {
    const result = await updatePerfil(userDataCopy);

    if (result.status === 204) {
      setShowSuccessModal(true);
      setUserData(userDataCopy);
      setIsErrorApiCep(false);
    } else if (result?.status === 400) {
      setUserDataCopy(userData);

      if (result.response.includes('TelefoneCelular__c')) {
        setShowErroPhoneDuplicatedModal(true);
        return;
      }
      setShowGenericErrorModal(true);
    }
  }

  function toggleEdit(isEditable, setIsEditable) {
    setIsEditable(!isEditable);
    toggleHaveAnyFieldsEditing();
  }

  function handleCancel(isEditable, setIsEditable) {
    setIsEditable(!isEditable);
    setUserDataCopy({ ...userData });
    toggleHaveAnyFieldsEditing();
    setUserDataValidation({});
    setIsErrorApiCep(false);
  }

  async function onClickSave(setIsEditable, setIsLoading) {
    try {
      setIsLoading(true);
      await handleUpdateProfile();
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
      setIsEditable(false);
      toggleHaveAnyFieldsEditing();
    }
  }
  useEffect(() => {
    (async function () {
      await getUserData();
    })();
  }, []);

  useEffect(() => {
    if (userData != {}) setUserDataCopy({ ...userData });
  }, [userData]);

  if (isLoading) {
    return <Spinner />;
  }
  return (
    <BaseComponentInternas>
      <HeaderStroke name={'Meu Perfil'} msgDadosCadastrais={'true'} />

      <AlertErrorMessage
        textAlign='start'
        message={
          'Mantenha seus dados cadastrais atualizados, principalmente telefone e e-mail.'
        }
        marginBottom={24}
      />
      <SocialMedias
        tema={tema}
        userDataCopy={userDataCopy}
        setUserDataCopy={setUserDataCopy}
        setUserData={setUserData}
        isUserDataEqualsUserDataCopy={isUserDataEqualsUserDataCopy}
        haveAnyFieldsEditing={haveAnyFieldsEditing}
        toggleEdit={toggleEdit}
        handleCancel={handleCancel}
        onClickSave={onClickSave}
      />
      <AccessData
        tema={tema}
        userData={userData}
        isUserDataEqualsUserDataCopy={isUserDataEqualsUserDataCopy}
        haveAnyFieldsEditing={haveAnyFieldsEditing}
        toggleEdit={toggleEdit}
        handleCancel={handleCancel}
      />
      <PersonalData
        tema={tema}
        userDataCopy={userDataCopy}
        setUserDataCopy={setUserDataCopy}
        setUserData={setUserData}
        isUserDataEqualsUserDataCopy={isUserDataEqualsUserDataCopy}
        haveAnyFieldsEditing={haveAnyFieldsEditing}
        toggleEdit={toggleEdit}
        handleCancel={handleCancel}
        onClickSave={onClickSave}
        isErrorApiCep={isErrorApiCep}
        setIsErrorApiCep={setIsErrorApiCep}
        userDataValidation={userDataValidation}
        setUserDataValidation={setUserDataValidation}
      />

      <HeaderSection
        title={'Destaques'}
        subtitle={'Fique por dentro das principais informações:'}
        notShowButton
        marginTop={120}
        mobileMarginTop={80}
        tema={tema}
      />
      <Destaques tema={tema} />

      {showSuccessModal && (
        <MessagePopUp
          title={'Dados alterados com sucesso!'}
          message={'As suas novas informações foram alteradas com sucesso.'}
        >
          <ButtonPrimary
            tema={tema}
            fullWidth
            onClick={() => setShowSuccessModal(false)}
          >
            CONFIRMAR
          </ButtonPrimary>
        </MessagePopUp>
      )}

      {showErroPhoneDuplicatedModal && (
        <MessagePopUp
          isError
          title={'Telefone duplicado'}
          message={'Informe um telefone que ainda não foi utilizado'}
        >
          <ButtonDanger
            fullWidth
            onClick={() => setShowErroPhoneDuplicatedModal(false)}
          >
            CONFIRMAR
          </ButtonDanger>
        </MessagePopUp>
      )}

      {showGenericErrorModal && (
        <MessagePopUp
          isError
          title={'Erro'}
          message={
            'Ocorreu um erro ao atualizar o perfil. Por favor tente novamente!'
          }
        >
          <ButtonDanger
            fullWidth
            onClick={() => setShowGenericErrorModal(false)}
          >
            CONFIRMAR
          </ButtonDanger>
        </MessagePopUp>
      )}
    </BaseComponentInternas>
  );
};

export default MeuPerfil;
